import { render, staticRenderFns } from "./project-contact.vue?vue&type=template&id=37fd544b&"
import script from "./project-contact.vue?vue&type=script&lang=js&"
export * from "./project-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports